<template>
  <div class="wraper">
    <div class="migration">
      <h2 class="title">Новый конструктор <br class="br" />личной страницы</h2>
      <a class="pBtn pBtn--blue button" :href="newPRWUrl" target="_blank"
        >Перейти</a
      >
      <div class="cards">
        <div class="card" v-for="(card, i) in cards" :key="i">
          <div class="wrap">
            <img
              class="img"
              :src="require(`@/assets/img/migration-icon-${i + 1}.svg`)"
            />
          </div>
          <h3 class="card__title" v-text="card.title"></h3>
          <div class="card__desc" v-text="card.desc"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      newPRWUrl: this.$store.state.isKZ
        ? "https://www.amway.kz/users"
        : "https://www.amway.ru/users",
      cards: [
        {
          title: "Мероприятия",
          desc: "Создавайте события и публикуйте их на странице"
        },
        {
          title: "Видео",
          desc: "Выбирайте и размещайте видео Amway на странице"
        },
        {
          title: "Интернет-магазин",
          desc: "Продавайте товары со своей страницы и получайте бонусы"
        },
        {
          title: "Удобные настройки",
          desc: "Создайте личную страницу и настройте ее под себя"
        }
      ]
    };
  }
};
</script>

<style scoped>
.wraper {
  background-color: #efefef;
  display: flex;
  justify-content: center;
  padding-top: 45px;
}
@media all and (max-width: 767px) {
  .wraper {
    padding: 22px 15px;
    background-color: #fff;
  }
}
.migration {
  display: grid;
  grid-template: auto auto / 40% 60%;
  padding: 45px 60px;
  background: #f2f9fc;
  border-radius: 10px;
  max-width: 1280px;
}
@media all and (max-width: 1200px) {
  .migration {
    grid-template: auto auto / auto 1fr;
    gap: 22px;
  }
}
@media all and (max-width: 1024px) {
  .migration {
    padding: 30px;
  }
}
@media all and (max-width: 767px) {
  .migration {
    padding: 22px;
  }
}
.title {
  grid-column: 1 / 2;
  grid-row: 1 / 2;
  font: normal 700 28px/30px sans-serif;
  margin: 0;
}
@media all and (max-width: 767px) {
  .title {
    font: normal 700 20px/24px sans-serif;
  }
}
.button {
  grid-column: 1 / 2;
  grid-row: 2 / -1;
  width: 200px;
  height: 43px;
  padding: 0;
  align-self: flex-end;
  text-decoration: none;
  display: grid;
  place-items: center;
}
.cards {
  grid-column: 2 / -1;
  grid-row: 1 / -1;
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 15px;
  column-gap: 30px;
}
@media all and (max-width: 1024px) {
  .title {
    grid-column: 1 / -1;
    grid-row: 1 / 2;
  }
  .button {
    grid-column: 1 / -1;
    grid-row: 3 / -1;
  }
  .cards {
    grid-column: 1 / -1;
    grid-row: 2 / 3;
  }
}
@media all and (max-width: 768px) {
  .button {
    width: 100%;
  }
}
@media all and (max-width: 767px) {
  .cards {
    grid-template-columns: 1fr;
  }
}
.card {
  padding: 12px 8px;
  background: #ffffff;
  border-radius: 12px;
  display: grid;
  grid-template: max-content 1fr / min-content auto;
}
@media all and (max-width: 767px) {
  .card {
    padding: 10px 8px;
  }
}
.wrap {
  width: 56px;
  height: 56px;
  grid-column: 1 / 2;
  grid-row: 1 / -1;
}
.img {
  object-fit: cover;
  object-position: center;
  width: 100%;
  height: 100%;
}
.card__title {
  font: normal 600 16px/22px sans-serif;
  color: #0a467e;
  margin: 0;
  grid-column: 2 / -1;
  grid-row: 1 / 2;
  margin-bottom: 5px;
}
.card__desc {
  font: normal 400 14px/19px sans-serif;
  color: #56565a;
  grid-column: 2 / -1;
  grid-row: 2 / -1;
}
@media all and (max-width: 767px) {
  .card__title {
    font: normal 700 15px/20px sans-serif;
  }
  .card__desc {
    font: normal 400 13px/18px sans-serif;
  }
}
</style>
